import Config from 'services/config/config';
import { SHOW_HIDE_TOAST } from 'services/redux/sales/appNotifications/type';
import { store } from 'services/redux/store';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  CREATE_ADS_CAMPAIGN,
  GET_CAMPAIGN_LIST,
  UPDATE_CAMPAIGN,
  INVOICE_CREATION
} from './type';


export const addCampaignData = (requestData) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      requestData,
      Config.brandActivation.createCampagin
    );

    if (res) {
      const {data} = res;
      dispatch({
        type: CREATE_ADS_CAMPAIGN, 
        payload: data
      });
      return true;
    }
  };

export const getCampaignData = (page=1, filter = null, status = null, campaignId = null) => async (dispatch) => {
    let url = Config.brandActivation.campaginData + `?page=${page}`
    if(filter !== null){
        url+= `&campaign_type=${filter.campaign_type}&campaign_subtype=${filter.campaign_subtype}&start_date=${filter.start_date}&created_by=${filter.created_by}&created_email=${filter.created_email}&status_name=${filter.status_name}&check_invoice=${filter.check_invoice}`
    }
    if(status!== null){
        url+= `&status=${status}`
    }
    if(campaignId!== null){
      url+= `&campaign_id=${campaignId}`
    }
    const res = await callWebService(
        callTypes.get,
        '',
        url
    );
    if (res) {
      const {data} = res;
      dispatch({type: GET_CAMPAIGN_LIST, payload: data.response.data});
      return data.response.data;
    }
  };

  export const updateCampaignData = (requestData) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      requestData,
      Config.brandActivation.updateCampaginStatus
    );
    if (res?.data?.response?.status === true) {
      const {data} = res;
      dispatch({type: UPDATE_CAMPAIGN, payload: data.response.data});
      return true;
    }
  };

  export const createInvoiceForCampaign = (requestData) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      requestData,
      Config.brandActivation.invoiceCreationCampaign
    );
    if (res?.data?.response?.status === true) {
      const {data} = res;
      dispatch({type: INVOICE_CREATION, payload: data.response.data});
      return true;
    }
  };

